import request from "@/router/axios";

// 获取应急物资入库单列表（分页）
export const getList = (data) => {
  return request({
    url: "/api/produce/emergency-material-stockin/select/page",
    method: "post",
    data,
  });
};

// 获取应急物资入库单列表（去重分页）
export const getDistinctList = (data) => {
  return request({
    url: "/api/produce/emergency-material-stockin/select/distinct/page",
    method: "post",
    data,
  });
};

// 获取应急物资入库单详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/emergency-material-stockin/select/id",
    method: "get",
    params: { id },
  });
};

// 更新应急物资入库单
export const update = (data) => {
  return request({
    url: "/api/produce/emergency-material-stockin/update",
    method: "post",
    data,
  });
};

// 删除应急物资入库单（单个）
export const remove = (id) => {
  return request({
    url: "/api/produce/emergency-material-stockin/delete/id",
    method: "get",
    params: { id },
  });
};

// 批量删除应急物资入库单
export const removeBatch = (ids) => {
  return request({
    url: "/api/produce/emergency-material-stockin/delete/ids",
    method: "get",
    params: { ids },
  });
};

// 新增应急物资入库单（不需要对接，但保留接口定义）
export const add = (data) => {
  return request({
    url: "/api/produce/emergency-material-stockin/insert",
    method: "post",
    data,
  });
};
